import { Component, computed, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { AbstractControl } from '@angular/forms';

import { map, startWith, switchMap } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BoxComponent,
  DotComponent,
  FormFieldComponent,
  IconButtonComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import { EvaluationFieldLabelComponent } from '../evaluation-field-label/evaluation-field-label.component';

@Component({
  selector: 'rt-evaluation-question-card',
  templateUrl: './evaluation-question-card.component.html',
  styleUrls: ['./evaluation-question-card.component.less'],
  imports: [
    BoxComponent,
    DotComponent,
    FormFieldComponent,
    IconButtonComponent,
    RtTooltip,
    TranslatePipe,
    EvaluationFieldLabelComponent,
  ],
})
export class EvaluationQuestionCardComponent {
  public readonly title = input<string>('');
  public readonly hint = input<string>('');
  public readonly required = input<boolean>(false);
  public readonly control = input.required<AbstractControl>();
  public readonly showValidationErrors = input<boolean>(false);
  public readonly canComment = input<boolean>(false);
  public readonly commentExpanded = input<boolean>(false);
  public readonly commentDiscovery = input<boolean>(false);

  public readonly commentToggle = output<void>();

  protected isControlInvalid = toSignal(
    toObservable(this.control).pipe(
      switchMap(control =>
        control.events.pipe(
          map(() => control.invalid),
          startWith(control.invalid),
        ),
      ),
    ),
    { initialValue: false },
  );

  protected hasError = computed(() => this.showValidationErrors() && this.isControlInvalid());
  protected filled = computed(() => !this.isControlInvalid());
}
